import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["activePage", "recordsTotalCount", "pageSizeOptions", "pageSize", "onPageChange", "onPageSizeChange"];
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { ButtonMode } from '../Button';
import { Dropdown } from '../Dropdown';
import { Flex } from '../Flex';
import { ChevronLeftOutlined, ChevronRightOutlined, TickCircleFilled } from '../Icon';
import { Menu } from '../Menu';
import { Spacer, SpaceVariant } from '../Spacer';
import { Typography, TypographyVariant } from '../Typography';
import { ELLIPSIS_MARKER, INITIAL_PAGE, PAGE_SIZE_OPTIONS } from './constants';
import { buildPages } from './pagesBuilder';
import { PaginationButton, ChevronButton, BorderlessPaginationButton, PageSizeDropdownBtn, StyledMenuItem } from './styled';
export var Pagination = function Pagination(_ref) {
  var _ref$activePage = _ref.activePage,
      activePage = _ref$activePage === void 0 ? INITIAL_PAGE : _ref$activePage,
      recordsTotalCount = _ref.recordsTotalCount,
      _ref$pageSizeOptions = _ref.pageSizeOptions,
      pageSizeOptions = _ref$pageSizeOptions === void 0 ? PAGE_SIZE_OPTIONS : _ref$pageSizeOptions,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? pageSizeOptions[0].value : _ref$pageSize,
      onPageChange = _ref.onPageChange,
      onPageSizeChange = _ref.onPageSizeChange,
      styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useState = useState(pageSize),
      internalPageSize = _useState[0],
      setInternalPageSize = _useState[1];

  var _useState2 = useState(activePage),
      internalActivePage = _useState2[0],
      setInternalActivePage = _useState2[1];

  var handlePageSizeChange = useCallback(function (newPageSize) {
    if (newPageSize !== internalPageSize) {
      setInternalPageSize(newPageSize);
      onPageSizeChange == null ? void 0 : onPageSizeChange(newPageSize);
    }
  }, [internalPageSize, onPageSizeChange]);
  var handlePageChange = useCallback(function (newPage) {
    if (newPage !== internalActivePage) {
      setInternalActivePage(newPage);
      onPageChange == null ? void 0 : onPageChange(newPage);
    }
  }, [internalActivePage, onPageChange]);
  useEffect(function () {
    if (activePage !== internalActivePage) setInternalActivePage(activePage);
  }, [activePage, internalActivePage]);
  useEffect(function () {
    if (pageSize !== internalPageSize) setInternalPageSize(pageSize);
  }, [pageSize, internalPageSize]);
  var incrementPage = useCallback(function () {
    handlePageChange(internalActivePage + 1);
  }, [handlePageChange, internalActivePage]);
  var decrementPage = useCallback(function () {
    handlePageChange(internalActivePage - 1);
  }, [handlePageChange, internalActivePage]);
  var totalPages = Math.ceil(recordsTotalCount / pageSize);
  var pages = useMemo(function () {
    return buildPages(totalPages, internalActivePage, ELLIPSIS_MARKER);
  }, [internalActivePage, totalPages]);
  return /*#__PURE__*/React.createElement(Spacer, _extends({
    space: SpaceVariant.S,
    justifyContent: "flex-end",
    fluid: true
  }, styleProps), /*#__PURE__*/React.createElement(Dropdown, {
    trigger: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageSizeDropdownBtn, {
      "data-test": "pageSize-btn"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: TypographyVariant.BODY_2
    }, pageSize != null ? pageSize : internalPageSize))),
    position: "bottom",
    anchor: "start",
    closeOnInsideClick: true
  }, /*#__PURE__*/React.createElement(Menu, {
    width: "80px",
    minWidth: "80px"
  }, pageSizeOptions.map(function (pageSizeOption) {
    return /*#__PURE__*/React.createElement(StyledMenuItem, {
      key: pageSizeOption.value,
      "data-test": "pageSize-" + pageSizeOption.value,
      onClick: function onClick() {
        return handlePageSizeChange(pageSizeOption.value);
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: TypographyVariant.BODY_2,
      marginRight: "xs"
    }, pageSizeOption.label), pageSizeOption.value === internalPageSize && /*#__PURE__*/React.createElement(TickCircleFilled, {
      width: "18px",
      height: "18px",
      color: "#37b387"
    })));
  }))), /*#__PURE__*/React.createElement(Spacer, {
    space: SpaceVariant.XXXS,
    justifyContent: "flex-end",
    fluid: true
  }, /*#__PURE__*/React.createElement(ChevronButton, {
    onClick: decrementPage,
    disabled: activePage === 1,
    "data-test": "pagination-left"
  }, /*#__PURE__*/React.createElement(ChevronLeftOutlined, null)), pages.map(function (page, index) {
    return page !== ELLIPSIS_MARKER ? /*#__PURE__*/React.createElement(PaginationButton, {
      "data-test": "pagination-page-" + page,
      key: page,
      selected: activePage === page,
      mode: activePage === page ? ButtonMode.FILL : ButtonMode.OUTLINE,
      onClick: function onClick() {
        return handlePageChange(page);
      }
    }, page) : /*#__PURE__*/React.createElement(BorderlessPaginationButton, {
      key: "elipsis" + index,
      mode: ButtonMode.LINK
    }, "...");
  }), /*#__PURE__*/React.createElement(ChevronButton, {
    onClick: incrementPage,
    disabled: activePage === totalPages,
    "data-test": "pagination-right"
  }, /*#__PURE__*/React.createElement(ChevronRightOutlined, null))));
};
export default Pagination;